import { AxiosError } from "axios";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";
import { FavoriteTicket } from "../models/favorite-ticket";

export const fetchFavoriteTickets = async () => {
    const response = await httpClient.get<FavoriteTicket[]>("/api/favorite-tickets");
    return response.data;
};

export const createFavoriteTicket = async (externalSystemID: number) => {
    try {
        const ticketResponse = await httpClient.post<FavoriteTicket>(`/api/favorite-tickets/${externalSystemID}`);
        return ticketResponse.data;
    } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 405) {
            showAlert({ title: "Maximálně si můžete uložit 10 online losů." });
        } else {
            throw error;
        }
    }
};

export const deleteFavoriteTicket = async (externalSystemID: number) => {
    httpClient.delete(`/api/favorite-tickets/${externalSystemID}`);
};

export default {
    fetchFavoriteTickets,
    createFavoriteTicket,
    deleteFavoriteTicket,
};
